import StandardRestError from './Standard'

class TrialEmailAliasError extends StandardRestError {
  static CODE = 'TRIAL_EMAIL_ALIAS'

  constructor(_serverMessage?: string, status = 422, body = {}) {
    super(
      'Use your email address without a + part. For Gmail, leave out the dots.',
      status,
      body,
    )
  }
}

export default TrialEmailAliasError
